// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import "./StatsSection.css";
// import CommonHeading from "../Common_Components/Common_Heading/Common_Heading";
// const statsData = [
//   { value: "1000+", label: "Placements Done" },
//   { value: "50+", label: "Countries Served" },
//   { value: "100%", label: "Success Rate" },
//   { value: "15+", label: "Years Experience" },
// ];
// export default function StatsSection() {
//   return (
//     <section className="stats_section container">
//       {" "}
//       <Container>
//         {" "}
//         <CommonHeading title="What Sets Us Apart" />
//         <Row className="g-3 justify-content-center">
//           {" "}
//           {statsData.map((item, index) => (
//             <Col lg={3} md={6} sm={6} xs={12} key={index}>
//               {" "}
//               <div className="stat-card">
//                 {" "}
//                 <h2 className="stat-value">{item.value}</h2>{" "}
//                 <p className="stat-label">{item.label}</p>{" "}
//               </div>{" "}
//             </Col>
//           ))}{" "}
//         </Row>{" "}
//       </Container>{" "}
//     </section>
//   );
// }

import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./StatsSection.css";
import CommonHeading from "../Common_Components/Common_Heading/Common_Heading";
const statsData = [
  { value: 1000, suffix: "+", label: "Placements Done" },
  { value: 50, suffix: "+", label: "Countries Served" },
  { value: 100, suffix: "%", label: "Success Rate" },
  { value: 15, suffix: "+", label: "Years Experience" },
];
const Counter = ({ value, suffix }) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let start = 0;
    const duration = 2000;
    const increment = value / (duration / 20);
    const counter = setInterval(() => {
      start += increment;
      if (start >= value) {
        setCount(value);
        clearInterval(counter);
      } else {
        setCount(Math.floor(start));
      }
    }, 20);
    return () => clearInterval(counter);
  }, [value]);
  return (
    <>
      {" "}
      {count} {suffix}{" "}
    </>
  );
};
export default function StatsSection() {
  return (
    <section className="stats_section">
      {" "}
      <Container>
        {" "}
        <CommonHeading title="What Sets Us Apart" />{" "}
        <Row className="g-3 justify-content-center">
          {" "}
          {statsData.map((item, index) => (
            <Col lg={3} md={6} sm={6} xs={12} key={index}>
              {" "}
              <div className="stat-card">
                {" "}
                <h2 className="stat-value">
                  {" "}
                  <Counter value={item.value} suffix={item.suffix} />{" "}
                </h2>{" "}
                <p className="stat-label"> {item.label} </p>{" "}
              </div>{" "}
            </Col>
          ))}{" "}
        </Row>{" "}
      </Container>{" "}
    </section>
  );
}
